import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import Header from '../../Header/Header';
import { useTabBarReducer } from '../../../hooks/tabMenuReducer/tabMenuReducer';
import TabMenu from '../../TabMenu/TabMenu';
import Carousel from '../../Carousel/Carousel';
import { getPayoutTableItems, getMySelectionScreen, getResultTabs } from './ResultsScreen.functions';
import { useEntryStore } from '../../../store/entry/entryStore';
import { isPickedHorse, useGetPickedHorse } from '../../../store/entry/entryActions';
import PayoutTable from '../../PayoutTable/PayoutTable';
import { usePredictorStore } from '../../../store/predictor/predictorStore';
import './ResultsScreen.scss';

const defaulPayoutTableItems = [
  {
    total: undefined,
    players: undefined,
    prize: undefined,
    correct: undefined,
    focused: false,
  },
];

const ResultsScreen = () => {
  const { t } = useTranslation();
  const pickedHorses = useGetPickedHorse();
  const { user } = useContext(UserContext);

  const amountCorrect = pickedHorses.filter(
    (pick) => isPickedHorse(pick) && pick?.selectionResult === 'W' && pick.active,
  ).length;
  const settled = useEntryStore((s) => s.entry?.settled);
  const [{ items, current }, { setTab }] = useTabBarReducer('my-selections', ['my-selections', 'payout-table']);
  const predictorStats = usePredictorStore((s) => s.predictorStats);
  const payoutTableItems = getPayoutTableItems({
    predictorStats,
    amountCorrect,
    currencyCode: user.currency ?? 'GBP',
  });
  const resultsTabs = getResultTabs({ pickedHorses });
  const currentScore = payoutTableItems.filter((item) => item.focused);
  return (
    <>
      <Header showPrize={false} />

      <div className={'results-screen'}>
        <TabMenu
          items={items}
          onClick={(tab) => {
            setTab({ item: tab, selectionMade: false });
          }}
        />
        <div className={'results-screen__wrapper'}>
          <Carousel
            items={[
              getMySelectionScreen({ settled: settled ?? false, resultsTabs, t }),
              {
                node: (
                  <div className={'payout-table-container'}>
                    <PayoutTable
                      header={'your-current-score'}
                      items={currentScore.length > 0 ? currentScore : defaulPayoutTableItems}
                    />
                    <PayoutTable header={'all-players'} items={payoutTableItems} />
                  </div>
                ),
                id: 'payout-table',
              },
            ]}
            current={current}
            setCurrent={({ id }) => setTab({ item: id, selectionMade: false })}
          />
        </div>
      </div>
    </>
  );
};
export default ResultsScreen;
